module.exports = __webpack_public_path__ + "static/media/Food.838e94af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Food.png
// module id = 340
// module chunks = 0